import { Action, Reducer } from 'redux'

type State = string

const initialState: State = ''

const actions: any = {
  setOverrideTodayDate(_state: State, action: { type: string; payload: string }): State {
    return action.payload
  },
}

// biome-ignore lint/style/useDefaultParameterLast: ok
export const overrideTodayDateReducer: Reducer<string> = (state = initialState, action: Action) => {
  if (actions[action.type]) return actions[action.type](state, action)
  return state
}
